<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Envios de Holerite</h4>
          <form @submit.prevent="handleUpload" class="text-left">
            <div class="row">
              <!-- Seleção de funcionário -->
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="funcionario">Funcionário</label>
                  <select
                    id="funcionario"
                    v-model="payload.id_funcionario"
                    class="form-control"
                    :disabled="isLoading || funcionarios.length === 0"
                  >
                    <option value="" disabled>Selecione um funcionário</option>
                    <option
                      v-for="funcionario in funcionarios"
                      :key="funcionario.id"
                      :value="funcionario.id"
                    >
                      {{ funcionario.nome }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Seleção de mês -->
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="mesReferencia">Mês Referente</label>
                  <select
                    v-model="mesSelecionado"
                    class="form-control"
                    :disabled="isLoading"
                  >
                    <option
                      v-for="mes in meses"
                      :key="mes.value"
                      :value="mes.value"
                    >
                      {{ mes.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Seleção de Tipo -->
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="tipoHolerite">Tipo de Holerite</label>
                  <select
                    id="tipoHolerite"
                    v-model="tipoSelecionado"
                    class="form-control"
                    :disabled="isLoading"
                  >
                    <option value="Mensal">Mensal</option>
                    <option value="Adiantamento">Adiantamento</option>
                    <option value="Bônus">Bônus</option>
                    <option value="13º Salário">13º Salário</option>
                    <option value="Férias">Férias</option>
                    <option value="Rescisão">Rescisão</option>
                    <option value="Complementar">Complementar</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Input de arquivo -->
            <div class="form-group">
              <label for="fileUpload">Selecionar Arquivo</label>
              <div class="custom-file">
                <input
                  id="fileUpload"
                  type="file"
                  accept="application/pdf"
                  @change="onFileChange"
                  :disabled="isLoading"
                  class="custom-file-input"
                  ref="fileInput"
                />
                <label class="custom-file-label" for="fileUpload">
                  {{ selectedFileName || "Escolha um arquivo..." }}
                </label>
              </div>
            </div>

            <!-- Alerta fixo -->
            <div class="alert alert-danger mt-2" role="alert">
              <strong>ATENÇÃO:</strong>
              <ul class="mb-0">
                <li>
                  O Arquivo deve conter somente um holerite por folha.
                </li>
              </ul>
            </div>

            <!-- Botão de envio -->
            <div class="text-right">
              <base-button
                type="success"
                :disabled="
                  !selectedFile ||
                    isLoading ||
                    !mesSelecionado ||
                    !payload.id_funcionario ||
                    !tipoSelecionado
                "
                @click="handleUpload"
                class="btn btn-primary mt-2"
              >
                <span v-if="isLoading">Enviando...</span>
                <span v-else>Enviar</span>
              </base-button>
            </div>
          </form>
        </card>
      </div>
    </div>

    <!-- Componente de loading -->
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      ></loading>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card } from "@/components/index";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      selectedFile: null,
      selectedFileName: "",
      mesSelecionado: "",
      tipoSelecionado: "Mensal",
      meses: this.gerarMeses(),
      payload: {
        id_funcionario: "",
      },
      funcionarios: [],
    };
  },
  mounted() {
    this.listarFuncionarios();
  },
  methods: {
    gerarMeses() {
      const meses = [];
      const hoje = new Date();
      for (let i = 0; i < 12; i++) {
        const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
        const mesFormatado = `${String(data.getMonth() + 1).padStart(
          2,
          "0",
        )}/${data.getFullYear()}`;
        const dataCompleta = `${data.getFullYear()}-${String(
          data.getMonth() + 1,
        ).padStart(2, "0")}-01`;
        meses.push({ label: mesFormatado, value: dataCompleta });
      }
      return meses;
    },

    onFileChange(event) {
      const file = event.target.files[0];

      if (file && file.type === "application/pdf") {
        if (file.size > 5 * 1024 * 1024) {
          swal(
            "Erro",
            "O arquivo selecionado é muito grande. O tamanho máximo permitido é 5MB.",
            "error",
          );
          event.target.value = "";
          return;
        }
        this.selectedFile = file;
        this.selectedFileName = file.name;
      } else {
        this.selectedFile = null;
        this.selectedFileName = "";
        swal("Erro", "O arquivo selecionado não é um PDF válido.", "error");
        event.target.value = "";
      }
    },

    async listarFuncionarios() {
      this.isLoading = true;

      try {
        const response = await this.axios.post(
          "/api/empregado/listarEmpregados2",
          {
            setDB: this.$cookies.get("db"),
            idUsuario: this.$cookies.get("idUsuario"),
          },
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        this.funcionarios = response.data.data.dados || [];
      } catch (error) {
        console.error("Erro ao carregar funcionários:", error);
        swal("Erro", "Não foi possível carregar os funcionários.", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async handleUpload() {
      if (
        !this.selectedFile ||
        !this.mesSelecionado ||
        !this.payload.id_funcionario
      ) {
        swal(
          "Erro",
          "Selecione um arquivo, um mês, um tipo e um funcionário para enviar.",
          "error",
        );
        return;
      }

      this.isLoading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("setDB", this.$cookies.get("db"));
      formData.append("mesReferencia", this.mesSelecionado);
      formData.append("id_funcionario", this.payload.id_funcionario);
      formData.append("tipo_holerite", this.tipoSelecionado);

      try {
        const response = await this.axios.post(
          "/api/envioHoleriteIndividual",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        );

        swal(
          "Sucesso",
          response.data.message || "Arquivo enviado com sucesso!",
          "success",
        );

        this.selectedFile = null;
        this.selectedFileName = "";
        this.mesSelecionado = "";
        this.tipoSelecionado = "Mensal";
        this.payload.id_funcionario = "";
        this.$refs.fileInput.value = "";

        setTimeout(() => location.reload(), 2000);
      } catch (error) {
        this.isLoading = false;
        if (
          error.response.data.message ===
          "Arquivo ja existe para o CPF, mês e tipo informados."
        ) {
          // Mostra um modal de confirmação
          const resultSwal = await swal.fire({
            title: "Arquivo já existe!",
            text: "Deseja substituir o arquivo existente?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Substituir",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          });

          if (resultSwal.value) {
            this.isLoading = true;
            // Enviar novamente com parâmetro 'substituir=true'
            formData.append("substituir", "true");

            try {
              const response = await this.axios.post(
                "/api/envioHoleriteIndividual",
                formData,
                {
                  headers: { "Content-Type": "multipart/form-data" },
                },
              );

              swal(
                "Sucesso",
                response.data.message || "Arquivo enviado com sucesso!",
                "success",
              );

              // Resetando os campos
              this.selectedFile = null;
              this.selectedFileName = "";
              this.mesSelecionado = "";
              this.tipoSelecionado = "Mensal";
              this.payload.id_funcionario = "";
              this.$refs.fileInput.value = "";
            } catch (error) {
              swal("Erro", "Falha ao substituir o arquivo.", "error");
            }
          }
        } else {
          console.error("Erro ao enviar arquivo:", error);
          swal("Erro", "Falha ao enviar o arquivo.", "error");
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.mt-0 {
  margin-top: 0;
}

.alert-danger {
  font-size: 0.875rem;
  background-color: #f8d7da;
  color: #721c24;
  border-color: #f5c6cb;
  padding: 0.75rem 1.25rem;
  border-radius: 0.25rem;
}

.custom-file-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-right {
  text-align: right;
}
</style>
